<div class="hotel-t-content" [class.modal-mode]="componentResults" style="position: relative" [ngStyle]="{ 'margin-bottom': componentResults ? '70px' : '35px' }">
  <div *ngIf="componentResults" class="d-flex justify-content-between align-items-center mb-4 mt-3">
    <div class="d-flex align-items-center">
      <img src="../../../../../assets/img/app/categories-search-box/icon-seguro.svg" style="width: 26px" alt="" />
      <h3 class="mb-0 ml-2" style="font-family: &quot;Rubik&quot;, serif">Editar búsqueda de asistencia</h3>
    </div>
    <div>
      <button type="button" class="close btn-closed" aria-label="Close" (click)="close()">
        <span aria-hidden="true" style="font-size: 50px !important; font-weight: 100 !important">&times;</span>
      </button>
    </div>
  </div>

  <usb-edit-search-modal
    *ngIf="componentResults && loadingData"
    [category]="'asistencias'"
  ></usb-edit-search-modal>

  <form *ngIf="!loadingData" (ngSubmit)="_onSubmit(_form, $event)" [formGroup]="_form" novalidate>
    <!--***********Basic Data*************-->
    <div class="d-flex mb-3 mt-3" style="gap: 1em">
      <div class="w-100" id="form-destination">
        <div class="position-relative">
          <input
            id="origin"
            name="origin"
            matInput
            class="form-control input-search-box"
            style="background-color: white"
            (input)="filterCountries($event.target.value)"
            (focus)="getCountries()"
            aria-label="origin"
            formControlName="origin"
            [matAutocomplete]="auto"
            placeholder="Origen"
            type="text"
          />
          <img
            width="10"
            height="10"
            style="position: absolute; right: 1em; top: 40%"
            src="../../../../../assets/img/app/little-icons/arrow-down-black.svg"
          />
          <mat-autocomplete
            id="matCountry"
            #matCountry
            #auto="matAutocomplete"
            [displayWith]="displayCountry"
            (optionSelected)="updateMySelectionNationality($event.option.value)"
          >
            <mat-option
              *ngFor="let country of filteredCountries"
              style="font-family: &quot;Poppins&quot;, sans-serif; padding: 0px 10px !important; height: 35px !important"
              [value]="country.country_code"
            >
              {{ country.country_name }}</mat-option
            >
          </mat-autocomplete>
        </div>
        <div class="message-error-field mt-1" *ngIf="_form.get('origin').invalid && _form.get('origin').touched">
          <ng-container *ngIf="_form.get('origin').hasError('required')">El origen es requerido para realizar la búsqueda.</ng-container>
          <ng-container *ngIf="_form.get('origin').hasError('notFromList')">Seleccione un país de la lista desplegable.</ng-container>
        </div>
      </div>
      <div class="w-100 position-relative" id="form-destination">
        <select name="destination"
                id="destination"
                class="form-control input-search-box select-style"
                formControlName="destination">
          <option value="null" disabled>Destino</option>
          <ng-container *ngFor="let destiny of destinyInsurance">
            <option value="{{ destiny.name }}">{{ destiny.label }}</option>
          </ng-container>
        </select>
        <img
          width="10"
          height="10"
          style="position: absolute; right: 1em; top: 30%"
          src="../../../../../assets/img/app/little-icons/arrow-down-black.svg"
        />
        <div class="message-error-field mt-1" *ngIf="_form.get('destination').invalid && _form.get('destination').touched">
          El destino es requerido para realizar la búsqueda.
        </div>
      </div>
      <div class="w-100" id="form-destination">
        <div class="form-group position-relative mb-0">
          <input
            type="hidden"
            readonly
            formControlName="beginDateEndDate"
            autocomplete="off"
            class="form-control"
            ngxDaterangepickerMd
            [locale]="{ applyLabel: 'ok', format: 'DD/MM/YYYY' }"
            startKey="start"
            endKey="end"
            [autoApply]="true"
            [closeOnAutoApply]="true"
            [minDate]="minDate"
            [maxDate]="maxDate"
            (startDateChanged)="startDateClicked($event)"
            (endDateChanged)="endDateClicked($event)"
            #dateRangePicker
            name="daterange"
          />
          <input
            type="text"
            readonly
            [value]="dateRangeLabel"
            placeholder="  Check-in - check-out"
            class="form-control input-search-box ngx-daterangepicker-action"
            (click)="openDatePickerSimple()"
            id="dateRangePickerTrigger"
          />
        </div>
        <div class="message-error-field mt-1" *ngIf="_form.get('beginDateEndDate').invalid && _form.get('beginDateEndDate').touched">
          Las fechas son requeridas para realizar la búsqueda.
        </div>
      </div>
    </div>

    <div class="d-flex" style="gap: 1em">
      <div style="width: 33.25%; position: relative" id="form-destination">
        <select name="serviceType" id="serviceType" class="form-control input-search-box select-style" formControlName="serviceType">
          <option value="null" disabled>Tipo viaje</option>
          <ng-container *ngFor="let type of typeTrip">
            <option value="{{ type.value }}">{{ type.label }}</option>
          </ng-container>
        </select>
        <img
          width="10"
          height="10"
          style="position: absolute; right: 1em; top: 30%"
          src="../../../../../assets/img/app/little-icons/arrow-down-black.svg"
        />
        <div class="message-error-field mt-1" *ngIf="_form.get('serviceType').value === null && _form.get('serviceType').touched">
          El tipo de viaje es requerido para realizar la búsqueda.
        </div>
      </div>
      <div style="width: 46.75%; position: relative" id="form-destination">
        <button
          #triggerButton
          type="button"
          class="form-control btn-usb-rp d-flex align-items-center justify-content-between element-config-passenger"
          (click)="_openModal(); expandedConfigPassenger()"
          [attr.aria-expanded]="!isCollapsed"
          aria-controls="false"
        >
          <p
            class="p-0 m-0 align-self-center align-middle font-poppins text-passenger-input"
            style="
              font-family: &quot;Poppins&quot;, sans-serif !important;
              font-size: 14px !important;
              font-weight: 600 !important;
              color: #464646;
            "
          >
            {{ passengers }}
          </p>

          <img
            width="10"
            height="10"
            style="position: absolute; right: 1em; top: 30%"
            src="../../../../../assets/img/app/little-icons/arrow-down-black.svg"
          />
        </button>
        <span class="help-block text-danger" *ngIf="_close && isCollapsed && _form.value['firstqtyAdults'] == 0"
          >Al menos selecciona 1 adulto.</span
        >
        <div
          (collapsed)="clickOutside($event)"
          (expanded)="($event)"
          [collapse]="!isCollapsed || _close"
          (click)="_over()"
          class="config-passenger"
        >
          <div class="row">
            <div class="col-xl-11 col-lg-11 col-md-12 col-sm-12 w-100">
              <!-- Modal Passengers -->
              <div #cardSelectorRoom class="card" style="padding: 0px 20px;" [ngStyle]="{ 'top': componentResults ? '-160px' : 'unset' }">
                <!-- Passengers Count -->
                <div class="row mt-4">
                  <div class="col-4 pr-0">
                    <div class="d-flex align-items-center justify-content-start h-100">
                      <label for="childs" style="margin-bottom: 0px; margin-top: 2px; font-family: 'Rubik' !important; font-size: 13px !important; font-weight: 600 !important;">Cantidad de pasajeros</label>
                    </div>
                  </div>

                  <div class="col-8 p-0">
                    <div class="input-group">
                      <button
                        type="button"
                        style="border: none; background-color: transparent; height: 34px; width: 34px"
                        (click)="decrementPassenger()"
                        [disabled]="qtyPax === 1"
                      >
                        <p class="mb-0" style="font-size: 20px; font-weight: 600">-</p>
                      </button>

                      <input
                        type="number"
                        id="qtyPaxInput"
                        class="form-control text-center p-0 d-flex align-items-center justify-content-center"
                        style="border-radius: 12px; max-width: 50px; padding: 0 !important;"
                        formControlName="qtyPax"
                        min="1"
                        max="20"
                        autocomplete="off"
                      />

                      <button
                        type="button"
                        style="border: none; background-color: transparent; height: 34px; width: 34px"
                        (click)="incrementPassenger()"
                        [disabled]="qtyPax >= 20"
                      >
                        <p class="mb-0" style="font-size: 20px; font-weight: 600">+</p>
                      </button>
                    </div>
                    <div class="text-danger small mt-1" *ngIf="_form.get('qtyPax').invalid && (_form.get('qtyPax').touched || _form.get('qtyPax').dirty)">
                      La cantidad de pasajeros debe estar entre 1 y 20 pasajeros.
                    </div>
                  </div>
                </div>

                <hr class="w-100" style="border-top: none; border-bottom: 2px dashed #dad9d7;" />

                <!-- Rooms -->
                <div class="mt-2">
                  <div class="w-100">
                    <div id="paxes" class="flex flex-column w-100" *ngIf="paxes && paxes.length > 0">
                      <div *ngFor="let paxGroup of paxes.controls; let j = index" class="select-ages">
                        <div [formGroup]="paxGroup" class="row mb-2">
                          <!-- EDAD -->
                          <div class="col-4 pr-0">
                            <div class="d-flex align-items-center justify-content-start h-100">
                              <p class="mb-0" style="font-family: 'Rubik' !important; font-size: 13px !important; font-weight: 600 !important;">
                                Edad de pasajero {{ j + 1 }}
                              </p>
                            </div>
                          </div>

                          <!-- AGE -->
                          <div class="col-3 p-0">
                            <div class="input-group h-100 align-items-center">
                              <button
                                type="button"
                                style="border: none; background-color: transparent; height: 34px; width: 34px"
                                (click)="decrementAge(j)"
                                [disabled]="isAgeDecrementDisabled(j)"
                              >
                                <p class="mb-0" style="font-size: 20px; font-weight: 600">-</p>
                              </button>
                              <ng-container>
                                <input
                                  type="text"
                                  formControlName="age"
                                  (input)="settingAge($event.target?.value, j)"
                                  (blur)="flushPendingAge()"
                                  [attr.min]="j === 0 ? 18 : 0"
                                  max="120"
                                  class="form-control p-3 input-age"
                                  [style.border-color]="paxes.at(j).get('age').invalid && paxes.at(j).get('age').touched ? '#e93a55' : null"
                                  style="
                                    font-size: 1rem !important;
                                    height: 38px !important;
                                    width: 50px !important;
                                    max-width: 50px !important;
                                    border-radius: 12px;
                                  "
                                  name="age"
                                  pattern="[0-9]*"
                                  inputmode="numeric"
                                  autocomplete="off"
                                />
                              </ng-container>
                              <button
                                type="button"
                                style="border: none; background-color: transparent; height: 34px; width: 34px"
                                (click)="incrementAge(j)"
                                [disabled]="paxes.at(j).get('age').value >= 120"
                              >
                                <p class="mb-0" style="font-size: 20px; font-weight: 600">+</p>
                              </button>
                            </div>
                          </div>

                          <!-- ADDONS (Select múltiple custom) -->
                          <div class="col-5 pl-0 position-relative">
                            <!-- Multi Select -->
                            <div class="custom-multiselect" (click)="toggleDropdown(j, $event)">
                              <div class="custom-select-trigger" [ngClass]="{'has-value': getSelectedAddons(j).length > 0}">
                                <span *ngIf="getSelectedAddons(j).length === 0" class="placeholder">Coberturas</span>

                                <span *ngIf="getSelectedAddons(j).length > 0" class="selected-text">
                                  {{ getSelectedAddonsLabels(j) }}
                                </span>

                                <img
                                  width="10"
                                  height="10"
                                  style="position: absolute; right: 1.2em; top: 35%"
                                  src="../../../../../assets/img/app/little-icons/arrow-down-black.svg"
                                />
                              </div>

                              <!-- Options -->
                              <div class="custom-select-dropdown" *ngIf="isDropdownOpen(j)" (click)="preventClose($event)">
                                <div *ngFor="let filter of passengerFilter" class="custom-option">
                                  <label class="custom-checkbox-label">
                                    <input
                                      type="checkbox"
                                      [checked]="isAddonSelected(j, filter.filter)"
                                      (change)="toggleAddon(j, filter.filter, $event)"
                                      class="custom-checkbox"
                                    />
                                    <span class="custom-checkbox-text">{{ filter.label }}</span>
                                  </label>
                                </div>
                              </div>
                            </div>

                            <!-- Semanas de embarazo (aparece si se selecciona "Embarazada") -->
                            <div *ngIf="getValueAddonsPregant(j)" class="position-relative mt-1">
                              <div class="custom-multiselect" (click)="togglePregnancyDropdown(j, $event)">
                                <div class="custom-select-trigger">
                                  <span *ngIf="!paxes.at(j).get('pregnancyWeeks')?.value" class="placeholder">Semanas embarazo</span>
                                  <span *ngIf="paxes.at(j).get('pregnancyWeeks')?.value" class="selected-text">
                                    Semana {{ paxes.at(j).get('pregnancyWeeks')?.value }}
                                  </span>
                                  <img
                                    width="10"
                                    height="10"
                                    style="position: absolute; right: 1.2em; top: 35%"
                                    src="../../../../../assets/img/app/little-icons/arrow-down-black.svg"
                                  />
                                </div>
                                <div class="custom-select-dropdown" *ngIf="isPregnancyDropdownOpen(j)" (click)="preventClose($event)">
                                  <div *ngFor="let week of pregnantWeekends" class="custom-option" (click)="selectPregnancyWeek(j, week)">
                                    <span class="custom-option-text">Semana {{ week }}</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row" style="height: 62px">
                  <div class="col-7 p-0"></div>
                  <div class="col-5 pl-0">
                    <button
                      (click)="_confirm()"
                      [attr.aria-expanded]="!isCollapsed"
                      aria-controls="false"
                      class="badge btn-choice-confirm"
                      style="border: none; min-width: 145px; width: 100%; height: 36px"
                      type="button"
                      [ngStyle]="{ 'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }"
                    >
                      Confirmar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="optional-section" [class.expanded]="isOptionalExpanded">
          <button
            type="button"
            (click)="toggleOptional()"
            class="text-option"
            style="font-size: 12px !important; font-weight: 600; border: none; background-color: transparent"
            [ngStyle]="{ color: getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }"
          >
            {{ isOptionalExpanded ? "Ocultar Opcionales" : "Opcionales" }}
          </button>

          <div class="optional-fields" *ngIf="isOptionalExpanded">
            <div class="form-group">
              <label for="wsp_phone_contact">WhatsApp de Contacto</label>
              <input
                type="tel"
                id="wsp_phone_contact"
                formControlName="wsp_phone_contact"
                placeholder="+54 11 1234-5678"
                class="form-control input-search-box"
                autocomplete="off"
              />
              <div class="text-danger small mt-1" *ngIf="_form.get('wsp_phone_contact').invalid && _form.get('wsp_phone_contact').touched">
                Ingresá un número de WhatsApp válido (ej: +54 11 1234-5678).
              </div>
            </div>

            <div class="form-group">
              <label for="email_contact">Email de Contacto</label>
              <input
                type="email"
                id="email_contact"
                formControlName="email_contact"
                placeholder="ejemplo@email.com"
                class="form-control input-search-box"
                autocomplete="off"
              />
              <div class="text-danger small mt-1" *ngIf="_form.get('email_contact').invalid && _form.get('email_contact').touched">
                Ingresá un email válido.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="width: 20%" id="form-destination">
        <button
          *ngIf="!userService._isGuest && userService.itineraryActive.length === 0"
          class="btn btn-search-hotel d-flex justify-content-center align-items-center inp"
          (click)="fileActive()"
          [ngStyle]="{ 'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }"
          type="button"
        >
          <span style="font-weight: 600 !important; text-transform: uppercase;">BUSCAR</span>
        </button>
        <button
          *ngIf="userService._isGuest || userService.itineraryActive.length > 0"
          class="btn btn-search-hotel d-flex justify-content-center align-items-center inp"
          [ngStyle]="{ 'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }"
          type="submit"
        >
          <span style="font-weight: 600 !important; text-transform: uppercase;">BUSCAR</span>
        </button>
      </div>
    </div>
  </form>
</div>

<!-- Template del componente -->
<div class="modal" [ngClass]="{ show: showModal }">
  <div class="modal-dialog">
    <div class="modal-content">
      <!-- Encabezado del modal -->
      <div class="modal-header">
        <h5 class="modal-title mt-2 text-black">{{ titleModal }}</h5>
        <!-- <button type="button" class="close" (click)="closeModal()">
          <span aria-hidden="true">&times;</span>
        </button> -->
      </div>
      <!-- Cuerpo del modal -->
      <div class="modal-body">
        <p class="mb-1 text-black">{{ messageModal }}</p>
      </div>
      <!-- Pie del modal -->
      <div class="d-flex flex-end justify-content-end mr-3 mb-4">
        <!-- <button type="button" class="btn btn-secondary" (click)="closeModal()">Cerrar</button> -->
        <button
          type="button"
          class="btn-confirm-modal rounded-pill"
          [ngStyle]="{ 'background-color': getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }"
          (click)="confirmAction()"
        >
          ACEPTAR
        </button>
      </div>
    </div>
  </div>
</div>
